var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('community-nav',{attrs:{"communityId":_vm.communityId}}),_c('order-list-common',{attrs:{"community-scope-id":_vm.communityId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }